import {FC} from "react";

interface StepZeroProps {
}

const StepZero: FC<StepZeroProps> = (props) => {
  const {} = props;
  
  return (
    <div>
      <h1>Loading Step</h1>
    </div>
  );
}

export default StepZero;